module.exports = __webpack_public_path__ + "static/media/javascript-4.f44b85b7.svg";